import { schema } from 'normalizr';
import { createAction, RSAA } from 'redux-api-middleware';
import { handleResponse, handleError, buildQueryString } from '../utils';

export const CREATE_DIGITIZED_CONTRACT_SUCCESS = 'CREATE_DIGITIZED_CONTRACT_SUCCESS';
export const CREATE_DIGITIZED_CONTRACT_REQUEST = 'CREATE_DIGITIZED_CONTRACT_REQUEST';
export const CREATE_DIGITIZED_CONTRACT_FAILURE = 'CREATE_DIGITIZED_CONTRACT_FAILURE';
export const FETCH_DIGITIZED_CONTRACT_REQUEST = 'FETCH_DIGITIZED_CONTRACT_REQUEST';
export const FETCH_DIGITIZED_CONTRACT_SUCCESS = 'FETCH_DIGITIZED_CONTRACT_SUCCESS';
export const FETCH_DIGITIZED_CONTRACT_FAILURE = 'FETCH_DIGITIZED_CONTRACT_FAILURE';
export const FETCH_DIGITIZED_CONTRACTS_REQUEST = 'FETCH_DIGITIZED_CONTRACTS_REQUEST';
export const FETCH_DIGITIZED_CONTRACTS_SUCCESS = 'FETCH_DIGITIZED_CONTRACTS_SUCCESS';
export const FETCH_DIGITIZED_CONTRACTS_FAILURE = 'FETCH_DIGITIZED_CONTRACTS_FAILURE';
export const UPDATE_DIGITIZED_CONTRACT_REQUEST = 'UPDATE_DIGITIZED_CONTRACT_REQUEST';
export const UPDATE_DIGITIZED_CONTRACT_SUCCESS = 'UPDATE_DIGITIZED_CONTRACT_SUCCESS';
export const UPDATE_DIGITIZED_CONTRACT_FAILURE = 'UPDATE_DIGITIZED_CONTRACT_FAILURE';

export const digitizedContractsSchema = new schema.Entity(
  'digitizedcontracts',
  {},
  { idAttribute: 'contractId' },
);

export const fetchDigitizedContract = contractId =>
  createAction({
    endpoint: `${window.config.apiUrl}/digitizedcontracts/${contractId}`,
    method: 'GET',
    types: [
      { type: FETCH_DIGITIZED_CONTRACT_REQUEST },
      {
        type: FETCH_DIGITIZED_CONTRACT_SUCCESS,
        payload: (action, state, res) => {
          return handleResponse(digitizedContractsSchema, action, state, res);
        },
        meta: (action, state, res) => ({
          totalCount: parseInt(res.headers.get('Total-Count'), 10),
        }),
      },
      { type: FETCH_DIGITIZED_CONTRACT_FAILURE, payload: handleError },
    ],
  });

export const uploadContracts = values => {
  const formData = new FormData();
  formData.append('file', values[0]);

  return createAction({
    endpoint: `${window.config.apiUrl}/digitizedcontracts`,
    method: 'POST',
    body: formData,
    options: {
      isFileUpload: true,
    },
    types: [
      { type: CREATE_DIGITIZED_CONTRACT_REQUEST },
      {
        type: CREATE_DIGITIZED_CONTRACT_SUCCESS,
      },
      {
        type: CREATE_DIGITIZED_CONTRACT_FAILURE,
        payload: handleError,
      },
    ],
  });
};

/**
 * Fetch uploaded digitized contracts.
 *
 * @return {object} - Redux api middleware action that triggers & handles the request.
 */
export const fetchDigitizedContracts = ({ pendingReviewal = true } = {}) => ({
  [RSAA]: {
    endpoint: `${window.config.apiUrl}/digitizedcontracts?${buildQueryString({ pendingReviewal })}`,
    method: 'GET',
    types: [
      { type: FETCH_DIGITIZED_CONTRACTS_REQUEST },
      {
        type: FETCH_DIGITIZED_CONTRACTS_SUCCESS,
        payload: (action, state, res) =>
          handleResponse([digitizedContractsSchema], action, state, res),
        meta: {},
      },
      {
        type: FETCH_DIGITIZED_CONTRACTS_FAILURE,
        payload: handleError,
        meta: {},
      },
    ],
  },
});
